import { createContext } from 'react';
import type { ListState } from 'react-stately';
import type { Item } from '#domains/items';

type ComboboxState = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
} & ListState<Item>;

type Context = {
  state: ComboboxState;
  triggerRef: React.RefObject<HTMLDivElement | null>;
};

export const ComboboxContext = createContext<Context | undefined>(undefined);
